import { PlatformId } from '../../../../../myApi';
import { PlatformsFilter } from '../../filterTypes';
import { platforms } from '../../../../../utils/platforms';

export type State = Partial<Record<PlatformId, boolean>>;
export const initialState : State = {};

export function preProcessState(filter: PlatformsFilter) : State {
  const state : State = {};

  if (filter.platforms === undefined) {
    platforms.forEach((x) => {
      state[x.id] = true;
    });
  } else {
    filter.platforms.forEach((x) => {
      state[x] = true;
    });
  }

  return state;
}

export function postProcessState(state: State) : PlatformsFilter {
  const newFilter : PlatformsFilter = { platforms: [] };

  Object.entries(state).forEach(([key, value]) => {
    if (value) {
      newFilter.platforms?.push(key as unknown as PlatformId);
    }
  });

  if (newFilter.platforms?.length === platforms.length) {
    newFilter.platforms = undefined;
  }

  return newFilter;
}
